import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Dino from '../mathLines/Dino';
import GameBackground from '../mathLines/GameBackground';
import SoundAssetKeys from '../SoundAssetKeys';
import EndDialog from '../UI/EndDialog';

export default class End extends Phaser.Scene {
  static get KEY() { return 'End'; }

  create() {
    console.log('End');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._math_lines_music, this, .3, true);

    this.anims.create({ key: 'char-1-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-1-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-happy_', start: 1, end: 7 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-happy_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-1-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-1-blink_', start: 1, end: 3 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-2-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-2-blink_', start: 1, end: 3 }), frameRate: 20 });

    this.bg = new GameBackground(this, this.mid.x * 2, this.mid.y * 2);
    this.bg.addBackgroundImage('sky-bg');
    this.bg.setClouds(true);

    this.trees = [];
    this.plantTree(90, this.mid.y * 2 - 100);
    this.plantTree(936, this.mid.y * 2 - 100);

    this.char1 = new Dino(this, 1);
    this.char1.x = -(this.char1.getBounds().width + 50);
    this.char1.endX = this.char1.getBounds().width / 2 + 50;
    this.char1.y = this.mid.y * 2 - 50;

    this.char2 = new Dino(this, 2);
    this.char2.x = this.mid.x * 2 + this.char2.getBounds().width / 2;
    this.char2.endX = this.mid.x * 2 - this.char2.getBounds().width / 2 - 50;
    this.char2.y = this.mid.y * 2 - this.char2.getBounds().height / 2 - 50;

    this.time.delayedCall(200, () => {
      this.addPopUp();
    });
  }

  addPopUp() {
    this.time.delayedCall(500, () => {
      this.char1.walkIn(this.char1.endX,500,'dance');
    });
    this.time.delayedCall(1500, () => {
      this.char2.walkIn(this.char2.endX,500,'dance');
    });

    const endDialog = new EndDialog(this, ['PLAY AGAIN'],'yes');
    endDialog.x = this.mid.x - endDialog.getBounds().width / 2;
    endDialog.y = -(endDialog.getBounds().height / 2);
    this.children.moveTo(endDialog, 1);

    endDialog.once('DIALOG_SELECT', () => {this.handleDialogInput();});

    ABCyaPhaser.Tweens.addTween(endDialog, 600, { y: this.mid.y - endDialog.getBounds().height / 2 - 100 }, Phaser.Math.Easing.Back.Out);
  };

  handleDialogInput() {
    this.cleanUp();
  };

  plantTree(xPos,yPos) {
    const tree = ABCyaPhaser.Images.addImage(0, 0, 'tree', this).setOrigin(.5, 1);
    tree.x = xPos;
    tree.y = yPos;
    tree.scaleY = 0;
    tree.alpha = 0;
    this.trees.push(true);

    ABCyaPhaser.Tweens.addTween(tree, 700, { alpha: 1,scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  };

  cleanUp() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    this.sound.stopAll();
    this.tweens.killAll();

    this.titleSprite = null;
    this.goBtn = null;

    this.scene.start('Intro');
  };

  update() {
    if (this.char1) this.char1.tick();
    if (this.char1) this.char2.tick();
  };
}